
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-map .visually-hidden{
    position:absolute;
    width:1px;
    height:1px;
    padding:0;
    margin:-1px;
    overflow:hidden;
    clip:rect(0, 0, 0, 0);
    white-space:nowrap;
    border-width:0;
  }
  .se-map figure{
    margin:0 auto;
    max-width:100%;
  }
  @media (min-width: 480px){
  .se-map figure{
      max-width:65%
  }
    }
  .se-map #us-map{
    display:block;
    width:100%;
    height:100%;
  }
  .se-map path,
  .se-map circle{
    transition:fill 6s ease;
    fill:var(--brand-primary-3) !important;
  }
  .se-map .highlighting path.highlighted,
    .se-map .highlighting circle.highlighted{
      stroke-linejoin:round;
      fill:var(--brand-primary-2) !important;
    }
  .se-map #path67{
    fill:none !important;
    stroke:var(--brand-primary-3) !important;
    cursor:default;
  }
  .se-map--vector-wrapper{
    position:relative;
  }
  .se-map--state-label{
    display:none;
    position:absolute;
    font-size:0.75rem;
    color:#fff;
  }
  @media (min-width: 680px){
  .se-map--state-label{
      display:block
  }
    }
  .se-map--state-label.AL{
      bottom:28%;
      left:66%;
    }
  .se-map--state-label.AK{
      bottom:14%;
      left:10%;
    }
  .se-map--state-label.AZ{
      bottom:36%;
      left:19%;
    }
  .se-map--state-label.AR{
      bottom:34%;
      left:55%;
    }
  .se-map--state-label.CA{
      bottom:48%;
      left:6%;
    }
  .se-map--state-label.CO{
      bottom:50%;
      left:31%;
    }
  .se-map--state-label.CT{
      bottom:62.5%;
      left:89%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.DE{
      bottom:56.7%;
      left:88%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.FL{
      bottom:10.5%;
      left:78.5%;
    }
  .se-map--state-label.GA{
      bottom:27%;
      left:73%;
    }
  .se-map--state-label.HI{
      bottom:3%;
      left:27%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.ID{
      bottom:71%;
      left:18%;
    }
  .se-map--state-label.IL{
      bottom:55%;
      left:61%;
    }
  .se-map--state-label.IN{
      bottom:54%;
      left:66%;
    }
  .se-map--state-label.IA{
      bottom:61%;
      left:53%;
    }
  .se-map--state-label.KS{
      bottom:48%;
      left:44%;
    }
  .se-map--state-label.KY{
      bottom:46.5%;
      left:69%;
    }
  .se-map--state-label.LA{
      bottom:24%;
      left:55%;
    }
  .se-map--state-label.ME{
      bottom:82%;
      left:91%;
    }
  .se-map--state-label.MD{
      bottom:51%;
      left:87%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.MA{
      bottom:71%;
      left:95%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.MI{
      bottom:66%;
      left:68%;
    }
  .se-map--state-label.MN{
      bottom:80%;
      left:50.5%;
    }
  .se-map--state-label.MS{
      bottom:28%;
      left:60%;
    }
  .se-map--state-label.MO{
      bottom:46%;
      left:54.5%;
    }
  .se-map--state-label.MT{
      bottom:82%;
      left:27%;
    }
  .se-map--state-label.NE{
      bottom:59%;
      left:42%;
    }
  .se-map--state-label.NV{
      bottom:58%;
      left:12%;
    }
  .se-map--state-label.NH{
      bottom:74%;
      left:92.5%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.NJ{
      bottom:59.3%;
      left:88.5%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.NM{
      bottom:34%;
      left:29%;
    }
  .se-map--state-label.NY{
      bottom:70%;
      left:83%;
    }
  .se-map--state-label.NC{
      bottom:42%;
      left:81%;
    }
  .se-map--state-label.ND{
      bottom:81%;
      left:41%;
    }
  .se-map--state-label.OH{
      bottom:57%;
      left:71%;
    }
  .se-map--state-label.OK{
      bottom:37%;
      left:46%;
    }
  .se-map--state-label.OR{
      bottom:76%;
      left:8%;
    }
  .se-map--state-label.PA{
      bottom:62%;
      left:80%;
    }
  .se-map--state-label.RI{
      bottom:65%;
      left:92.5%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.SC{
      bottom:34%;
      left:77%;
    }
  .se-map--state-label.SD{
      bottom:70%;
      left:41%;
    }
  .se-map--state-label.TN{
      bottom:39%;
      left:66%;
    }
  .se-map--state-label.TX{
      bottom:22%;
      left:42%;
    }
  .se-map--state-label.UT{
      bottom:53%;
      left:21%;
    }
  .se-map--state-label.VT{
      bottom:82.5%;
      left:86.6%;
      color:var(--brand-primary-2);
    }
  .se-map--state-label.VA{
      bottom:49%;
      left:81%;
    }
  .se-map--state-label.WA{
      bottom:89%;
      left:10%;
    }
  .se-map--state-label.WV{
      bottom:51%;
      left:75%;
    }
  .se-map--state-label.WI{
      bottom:72%;
      left:58%;
    }
  .se-map--state-label.WY{
      bottom:66%;
      left:29%;
    }
  .se-map--state-label.DC{
      bottom:54%;
      left:88%;
      color:var(--brand-primary-2);
    }
  @media (min-width: 880px){
      .se-map--state-label.AL{
        bottom:29%;
        left:67%;
      }
      .se-map--state-label.CO{
        bottom:52%;
        left:32%;
      }
      .se-map--state-label.CT{
        bottom:63%;
        left:89%;
      }
      .se-map--state-label.DE{
        bottom:57.5%;
        left:88%;
      }
      .se-map--state-label.FL{
        bottom:11.5%;
        left:79%;
      }
      .se-map--state-label.GA{
        bottom:27%;
        left:74%;
      }
      .se-map--state-label.IN{
        bottom:55%;
        left:66.5%;
      }
      .se-map--state-label.LA{
        bottom:25%;
        left:56%;
      }
      .se-map--state-label.MD{
        bottom:52.8%;
        left:87.5%;
      }
      .se-map--state-label.MS{
        bottom:28%;
        left:61%;
      }
      .se-map--state-label.NJ{
        bottom:60%;
        left:89%;
      }
      .se-map--state-label.RI{
        bottom:66%;
        left:91.5%;
      }
      .se-map--state-label.SC{
        bottom:35%;
        left:78%;
      }
      .se-map--state-label.TN{
        bottom:40%;
        left:66%;
      }
      .se-map--state-label.DC{
        bottom:55%;
        left:88%;
      }
      .se-map--state-label figure{
        margin:0 auto;
        max-width:100%;
      }
    }
  @media (min-width: 1024px){
      .se-map--state-label.CT{
        bottom:68.5%;
        left:88.5%;
        color:#fff;
      }
      .se-map--state-label.MA{
        bottom:72%;
        left:89.8%;
        color:#fff;
      }
      .se-map--state-label.NH{
        bottom:75%;
        left:89.3%;
        color:#fff;
      }
      .se-map--state-label.NY{
        bottom:71%;
        left:83%;
      }
      .se-map--state-label.VT{
        bottom:79%;
        left:87.2%;
        color:#fff;
      }
      .se-map--state-label.WI{
        bottom:72%;
        left:59%;
      }
    }
  @media (min-width: 1580px){
  .se-map--state-label{
      font-size:1rem
  }

      .se-map--state-label.ME{
        bottom:85%;
        left:92%;
      }
      .se-map--state-label.MD{
        bottom:57.9%;
        left:82.6%;
        color:#fff;
      }
      .se-map--state-label.MA{
        bottom:72.1%;
        left:89.8%;
      }
      .se-map--state-label.NH{
        bottom:75%;
        left:89.5%;
      }
      .se-map--state-label.NJ{
        bottom:60%;
        left:86.3%;
        color:#fff;
      }
      .se-map--state-label.OH{
        bottom:58%;
        left:72%;
      }
    }
  @media (min-width: 1880px){
  .se-map--state-label{
      font-size:1.25rem
  }

      .se-map--state-label.MD{
        bottom:57.9%;
        left:82.5%;
      }
      .se-map--state-label.RI{
        bottom:67%;
        left:91.3%;
      }
    }
`;